import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import basketSelector from 'selectors/basket/basketSelector';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import BasketMsgEN from 'components/BasketMsg/locales/BasketMsg_en_US';
import BasketMsgFR from 'components/BasketMsg/locales/BasketMsg_fr_CA';

const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(BasketMsgEN, BasketMsgFR);

export default connect(
    createStructuredSelector({
        basket: basketSelector,
        localization: createStructuredSelector({
            freeShipping: getTextFromResource(getText, 'freeShipping')
        })
    })
);
